import PaytSuppyListPage from "@/pages/comp/supply/payt/payt_supply/list";
import PaytCashListPage from "@/pages/comp/supply/payt/payt_cash/list";
import TradeFixListPage from "@/pages/comp/supply/trade_fix/list";
import ListMoneyPage from "@/pages/comp/supply/simple_trade/list_money";

const routerArr:object[] = [
  {
    path: "/comp/payt/payt_supply/list",
    element: <PaytSuppyListPage></PaytSuppyListPage>,
  },
  {
    path: "/comp/payt/payt_cash/list",
    element: <PaytCashListPage></PaytCashListPage>,
  },
  {
    path: "/comp/supply/trade_fix/list",
    element: <TradeFixListPage></TradeFixListPage>,
  },
  {
    path: "/comp/supply/simple_trade/list_money",
    element: <ListMoneyPage></ListMoneyPage>,
  },
];

export default routerArr;